import React from 'react';
import { useState } from 'react';
import Menu from '../components/Menu.js';
import TextBlock from '../components/TextBlock.js';
import '../styles/index.css'

export default function Contact() {
	return(
		<div className="container text">
			<Menu />
			<div className="item text-container">
				<p>hello! to inquire about a shoot, please reach out to <a href="mailto:inquiry@eryefilm.com">inquiry@eryefilm.com</a> with:</p>
				<ul className="contact">
					<li><img src={'../flowers/1.png'} />both you and your partner's names</li>
					<li><img src={'../flowers/2.png'} />your contact details (email)</li>
					<li><img src={'../flowers/3.png'} />type of shoot you're looking for</li>
					<li><img src={'../flowers/4.png'} />choices of dates</li>
					<li><img src={'../flowers/5.png'} />city and country you're looking to shoot in</li>
					<li><img src={'../flowers/6.png'} />preferred payment currency</li>
				</ul>
				<p>looking forward to meeting you!</p>
				<div>
					<a href="https://instagram.com/erye.film" target="_blank" className="ig-icon">
						<img 
							alt={'Instagram logo'}
							src={require('../img/ig.png')}
						/>
					</a>
				</div>
			</div>
		</div>
	);
}